import React from "react";
import { Box, Typography } from "@mui/material";
import { DOCLINK_COLORS } from "@/config/colors";

/**
 * HubMed overview — compact stat tile: title top, value bottom-right, large icon clipped on the left.
 */
const HubMedOverviewStatCard = ({
  title,
  value,
  valueFormatter,
  Icon,
  BgIcon,
  bgColor,
  borderColor,
  iconColor,
}) => {
  const DecorativeIcon = BgIcon || Icon;
  const display =
    typeof valueFormatter === "function" ? valueFormatter(value) : value;
  const bg = bgColor || DOCLINK_COLORS.DARK_PURPLE;
  const border = borderColor || DOCLINK_COLORS.LIGHT_PURPLE;
  const iconCol = iconColor || DOCLINK_COLORS.LIGHT_PURPLE;

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minWidth: 0,
        width: "100%",
        minHeight: 112,
        borderRadius: "8px",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
        border: `2px solid ${border}`,
        backgroundColor: bg,
        color: "white",
        px: 1.5,
        py: 1.125,
      }}
    >
      {DecorativeIcon ? (
        <DecorativeIcon
          sx={{
            position: "absolute",
            left: { xs: -16, sm: -24 },
            bottom: { xs: -16, sm: -24 },
            fontSize: { xs: 92, sm: 124, md: 136 },
            color: iconCol,
            opacity: 0.1,
            pointerEvents: "none",
            zIndex: 0,
          }}
        />
      ) : null}

      <Typography
        component="div"
        sx={{
          position: "relative",
          zIndex: 1,
          fontWeight: 700,
          fontSize: { xs: "1.05rem", sm: "1.1rem", md: "1.125rem" },
          lineHeight: 1.3,
          color: "rgba(255,255,255,0.96)",
          pr: 1,
        }}
      >
        {title}
      </Typography>

      <Box sx={{ flex: 1, minHeight: 2 }} aria-hidden />

      <Typography
        component="div"
        sx={{
          position: "relative",
          zIndex: 1,
          alignSelf: "flex-end",
          mt: "auto",
          fontWeight: 800,
          fontSize: { xs: "1.95rem", sm: "2.4rem", md: "2.75rem" },
          lineHeight: 1,
          textAlign: "right",
        }}
      >
        {display}
      </Typography>
    </Box>
  );
};

export default HubMedOverviewStatCard;
